import React, { useCallback } from 'react';
import cc from 'classcat';
import { openLiveChat as doOpenLiveChat } from 'components/LiveChat';
import Button from 'components/Button';
import { supportEmailLink } from 'lib/constants';

interface Props {
  text: string;
  email: string;
  href?: string | null;
  color?: string;
  openLiveChat?: boolean;
  emailMasked?: boolean;
}

const AccessDeniedButton = ({
  text,
  email,
  href = '#',
  color = 'primary',
  openLiveChat = false,
  emailMasked = false
}: Props) => {
  const handleClick = useCallback(() => {
    if (__ENV__.GNATTA_API_KEY) {
      if (openLiveChat) {
        doOpenLiveChat('access-denied');
      }
    }
  }, [openLiveChat]);

  const formattedHref =
    !__ENV__.GNATTA_API_KEY && openLiveChat
      ? supportEmailLink
      : emailMasked
      ? href?.replace('?username={username}', '')
      : href?.replace('{username}', encodeURIComponent(email));

  return (
    <div key={text} className="accessDenied__button">
      <Button
        className={cc({
          'button--fullWidth': true,
          button__grey: color === 'secondary'
        })}
        name="accessDenied"
        unstyled={color === 'ghost'}
        tag={formattedHref ? 'Link' : 'div'}
        buttonText={text}
        onClick={handleClick}
        href={formattedHref}
      />
    </div>
  );
};

export default AccessDeniedButton;
